import _defineProperty from "/builds/elproag/cloud/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Keyframes } from '@ant-design/cssinjs';
var genNotificationPlacementStyle = function genNotificationPlacementStyle(token) {
  var _$concat$concat3, _componentCls;
  var componentCls = token.componentCls,
    notificationMarginEdge = token.notificationMarginEdge,
    animationMaxHeight = token.animationMaxHeight;
  var noticeCls = "".concat(componentCls, "-notice");
  var rightFadeIn = new Keyframes('antNotificationFadeIn', {
    '0%': {
      transform: "translate3d(100%, 0, 0)",
      opacity: 0
    },
    '100%': {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  var topFadeIn = new Keyframes('antNotificationTopFadeIn', {
    '0%': {
      top: -animationMaxHeight,
      opacity: 0
    },
    '100%': {
      top: 0,
      opacity: 1
    }
  });
  var bottomFadeIn = new Keyframes('antNotificationBottomFadeIn', {
    '0%': {
      bottom: -animationMaxHeight,
      opacity: 0
    },
    '100%': {
      bottom: 0,
      opacity: 1
    }
  });
  var leftFadeIn = new Keyframes('antNotificationLeftFadeIn', {
    '0%': {
      transform: "translate3d(-100%, 0, 0)",
      opacity: 0
    },
    '100%': {
      transform: "translate3d(0, 0, 0)",
      opacity: 1
    }
  });
  return _defineProperty({}, componentCls, (_componentCls = {}, _defineProperty(_componentCls, "&".concat(componentCls, "-top, &").concat(componentCls, "-bottom"), _defineProperty({
    marginInline: 0
  }, noticeCls, {
    marginInline: 'auto auto'
  })), _defineProperty(_componentCls, "&".concat(componentCls, "-top"), _defineProperty({}, "".concat(componentCls, "-fade-enter").concat(componentCls, "-fade-enter-active, ").concat(componentCls, "-fade-appear").concat(componentCls, "-fade-appear-active"), {
    animationName: topFadeIn
  })), _defineProperty(_componentCls, "&".concat(componentCls, "-bottom"), _defineProperty({}, "".concat(componentCls, "-fade-enter").concat(componentCls, "-fade-enter-active, ").concat(componentCls, "-fade-appear").concat(componentCls, "-fade-appear-active"), {
    animationName: bottomFadeIn
  })), _defineProperty(_componentCls, "&".concat(componentCls, "-topRight, &").concat(componentCls, "-bottomRight"), _defineProperty({}, "".concat(componentCls, "-fade-enter").concat(componentCls, "-fade-enter-active, ").concat(componentCls, "-fade-appear").concat(componentCls, "-fade-appear-active"), {
    animationName: rightFadeIn
  })), _defineProperty(_componentCls, "&".concat(componentCls, "-topLeft, &").concat(componentCls, "-bottomLeft"), (_$concat$concat3 = {
    marginInlineEnd: 0,
    marginInlineStart: notificationMarginEdge
  }, _defineProperty(_$concat$concat3, noticeCls, {
    marginInlineEnd: 'auto',
    marginInlineStart: 0
  }), _defineProperty(_$concat$concat3, "".concat(componentCls, "-fade-enter").concat(componentCls, "-fade-enter-active, ").concat(componentCls, "-fade-appear").concat(componentCls, "-fade-appear-active"), {
    animationName: leftFadeIn
  }), _$concat$concat3)), _componentCls));
};
export default genNotificationPlacementStyle;